export default __webpack_public_path__ + "static/media/2276.bb91955d.png";